import { motion } from "motion/react";

export interface ZoneNeighborhoodsProps {
  cityName: string;
  text: string;
}

export default function ZoneNeighborhoods({ cityName, text }: ZoneNeighborhoodsProps) {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">
            Conocemos {cityName}
          </h2>
          <div className="w-10 h-1 bg-primary rounded-full mb-8"></div>
          <div className="max-w-4xl">
            <p className="font-body text-lg text-text-secondary leading-relaxed">
              {text}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}